import { useState, useEffect } from "react";
import { Accordion, Card } from "react-bootstrap";
import messages from "messages";
// components
import { ReactComponent as OutlineCross } from "assets/svg/outline-cross.svg";
import CustomToggle from "./components/custom-toggle";
import IconButton from "components/icon-button";
import TaskRow from "./components/task-row";
// styles
import styles from "./styles.module.scss";
// types
import type { Task } from "../..";
// constants
import { TASK_TYPES } from "../../constants";

type Props = {
  variant: keyof typeof TASK_TYPES;
  tasks: Task[];
  show: boolean;
  onHide: () => void;
  onCancel: (arg: Task) => void;
};
const TaskStatus = ({ variant, tasks, show, onHide, onCancel }: Props) => {
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    if (show) {
      // check if intercom exists
      if ((window as any).Intercom) {
        (window as any).Intercom("hide");
      }
    }
  });

  const isDownload = variant === TASK_TYPES.download;

  return !show ? null : (
    <Accordion
      defaultActiveKey="0"
      className={styles["task-status"]}
      onMouseDown={(e) => e.stopPropagation()}
    >
      <Card className={styles["task-status__card"]}>
        <Card.Header className={styles["task-status__card-header"]}>
          <span>
            {isDownload ? messages.downloadQueue : messages.uploadQueue}
          </span>
          <CustomToggle
            eventKey="0"
            callback={() => setExpanded((s) => !s)}
            expanded={expanded}
            className={styles["task-status__action"]}
          />

          <IconButton
            className={styles["task-status__action"]}
            onClick={onHide}
          >
            <OutlineCross />
          </IconButton>
        </Card.Header>
        {tasks.length > 0 && (
          <Accordion.Collapse eventKey="0">
            <Card.Body className={styles["task-status__card-body"]}>
              {tasks.map((el) => (
                <TaskRow
                  key={el.id}
                  value={el}
                  onCancel={onCancel}
                  variant={variant}
                />
              ))}
            </Card.Body>
          </Accordion.Collapse>
        )}
      </Card>
    </Accordion>
  );
};

export default TaskStatus;
